import { APICall, GetRequest } from "../service"

const ControllerName = "Government"

export const GetCountryLookup = () =>
    GetRequest(`${ControllerName}/lookup`)
